import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './exchangeSummaryPage.css';
import Header from "../components/common/header";
import Footer from "../components/common/footer";
import { useExchangeUser } from '../../contexts/userExchangeProgramContext';

interface Order {
  city: string;
  state_id: string;
  pincode: string;
  store_city: string;
  total_price: string;
  customer_name: string;
  customer_mobile: string;
  customer_email: string;
  address_1: string;
  address_2: string;
  state: string;
  locality: string;
  old_brand_name: string;
  new_brand_name: string;
  state_name: string;
  store_name: string;
  locality_name: string;
  reference_doc: string;
  reference_doc_date: string;
  reference_doc_id: string;
  old_product_label: string;
  new_product_label: string;
}

const SummaryPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [storeOptions, setStoreOptions] = useState([]);
    const [error, setError] = useState<string | null>(null);
    const nameInputRef = useRef<HTMLInputElement>(null);
    const [showPolicyError, setShowPolicyError] = useState(false);
    const [showExchangeError, setShowExchangeError] = useState(false);
    const [orderInfo, setOrderInfo] = useState<Order | null>(null);
    const { order_id, user_id, formatDate,fetchCsrfToken } = useExchangeUser();
    const [loading,setLoading] = useState(false)
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const version = process.env.REACT_APP_VERSION;
    const prog_id = location.state?.prog_id;
    const storeData = location.state?.storeData
    //console.log("storeData: ---------------",storeData)

  // Checkbox states
  const [policyChecked, setPolicyChecked] = useState(false);
  const [exchangeValueChecked, setExchangeValueChecked] = useState(false);

  useEffect(() => {
    fetchAllInfoData();
  }, []);

  const fetchAllInfoData = async () => {
    try {
      
      const response = await fetch(`${backendUrl}api/v2/order-info/${order_id}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
    
          },
          credentials: "include",
          mode:"cors" 
                        
        }
      );
      const data = await response.json();
      //console.log("order info", data)
      if (data.data) {
        setOrderInfo(data.data || []);
      } else {
        setError('No stores found for the entered pincode');
      }
    } catch (err: any) {
      setError('Error fetching store options');
    }
  };

  const updateTncCheck = async () => {
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/tnc-check/${order_id}/${user_id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
      });
      const data = await response.json();
      setLoading(false)
      navigate('/exchange/verify-otp', { state: { prog_id } })
      window.scrollTo({ top: 0, behavior: 'smooth' })
      // Handle the response as needed
    } catch (err: any) {
      // Handle the error as needed
      setLoading(false)
    }
  };

  const handleConfirmExchange = () => {
    if (!policyChecked || !exchangeValueChecked) {
      // Show errors for unchecked checkboxes
      setShowPolicyError(!policyChecked);
      setShowExchangeError(!exchangeValueChecked);
    } else {
      // Perform the action if both checkboxes are checked
      setLoading(true);
      updateTncCheck();
    }
  };


  // Check if both checkboxes are checked to enable the button
  const isConfirmButtonEnabled = policyChecked && exchangeValueChecked;

  useEffect(() => {
    fetchSeoMetaDetails()
  },[]);

const fetchSeoMetaDetails = async () => {
    try {
        const code = 'exchange_summary_page'
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
      
            },
            credentials: "include",
            mode:"cors"      
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };

  return (
    <div>
      <Header />
      <main className="main-content-home container">
        <h4 className="main-heading">Summary </h4>

        <div className="daikin-progessbar">
          <div className="daikin-container">
            <div className="daikin-row">
              <ul className="daikin-proDetailssProcess">
                <li className="daikin-numOne active">
                  <div className="daikin-progNum"></div>
                  <div className="daikin-detailssSteps">Product Details</div>
                </li>
                <li className="daikin-numTwo active">
                  <div className="daikin-progNum active"></div>
                  <div className="daikin-detailssSteps">Personal Details</div>
                </li>
                <li className="daikin-numThree active">
                  <div className="daikin-progNum active"></div>
                  <div className="daikin-detailssSteps">Summary</div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="Store-details">
          <div className="store-heading">
            <h3>Store Details:</h3>
          </div>
          <div className="store-address">
            {/* <div className='store-address-city'>
                            <p className='label-title'>City:</p>
                            <p className='label-value'>{storeData.city}</p>
                        </div> */}
            <div className="store-address-city">
              <p className="label-title">Address:</p>
              <p className="label-value">{`${storeData.name},${storeData.address_1},${storeData.pincode}`}</p>
            </div>
          </div>
          <div className="store-heading">
            <h3>Customer Details:</h3>
          </div>
          <div className="user-details">
            <div className="store-address-city">
              <p className="label-title">Name:</p>
              <p className="label-value">{orderInfo?.customer_name}</p>
            </div>
            <div className="store-address-city">
              <p className="label-title">Mobile No:</p>
              <p className="label-value">{orderInfo?.customer_mobile}</p>
            </div>
            <div className="store-address-city">
              <p className="label-title">E-Mail ID:</p>
              <p className="label-value">{orderInfo?.customer_email}</p>
            </div>
            <div className="store-address-city">
              <p className="label-title">House Number:</p>
              <p className="label-value">{orderInfo?.address_1}</p>
            </div>
            <div className="store-address-city">
              <p className="label-title">Street Address:</p>
              <p className="label-value">{orderInfo?.address_2}</p>
            </div>
            <div className="store-address-city">
              <p className="label-title">Locality:</p>
              <p className="label-value">{orderInfo?.locality_name}</p>
            </div>
            <div className="store-address-city">
              <p className="label-title">Pincode:</p>
              <p className="label-value">{orderInfo?.pincode}</p>
            </div>
            <div className="store-address-city">
              <p className="label-title">City:</p>
              <p className="label-value">{orderInfo?.city}</p>
            </div>
            <div className="store-address-city">
              <p className="label-title">State:</p>
              <p className="label-value">{orderInfo?.state_name}</p>
            </div>
          </div>
          <div className="store-heading">
            <h3>Exchange Details:</h3>
          </div>
          <div className="lower-section-summary">
            <div className="product-data">
              <div className="lower-product-detail">
                <div className="store-address-city div_1">
                  <p className="label-title">Old Product:</p>
                  <p className="label-value">{orderInfo?.old_product_label}</p>
                </div>
                <div className="store-address-city div_2">
                  <p className="label-title">New Daikin Product:</p>
                  <p className="label-value">{orderInfo?.new_product_label}</p>
                </div>
                <div className="store-address-city div_3">
                  <p className="label-title">Brand:</p>
                  <p className="label-value">{orderInfo?.old_brand_name}</p>
                </div>
                <div className="store-address-city div_4">
                  <p className="label-title">Brand:</p>
                  <p className="label-value">{orderInfo?.new_brand_name}</p>
                </div>
              </div>
            </div>
            <div className="exchange-data">
              <div className="store-address-city">
                <p className="label-title">Exchange Value:</p>
                <p className="label-value">
                  &#8377; {orderInfo?.total_price}
                </p>
                <p className="tc-daikin-subject-summary">
                  Subject to Quality Check of the Product
                </p>
                <p className="tc-daikin-summary">*T&C Applied</p>
              </div>
              <div className="store-address-city">
                <p className="label-title">Invoice Number:</p>
                <p className="label-value">{orderInfo?.reference_doc}</p>
              </div>
              <div className="store-address-city">
                <p className="label-title">Purchase Date:</p>
                <p className="label-value">{formatDate(orderInfo?.reference_doc_date)}</p>
              </div>
            </div>
          </div>
          <p className="terms-and-condition-summary-page">
            <p>
              {" "}
              1. Customers who have purchased a new Daikin Air Conditioner
              (AC) are eligible to participate.
            </p>
            <p>
              {" "}
              2. The old AC should be available with all parts and components.
            </p>
            <p>
              {" "}
              3. Please ensure the product is uninstalled and ready for
              pickup.
            </p>
            <p>
              {" "}
              4. Ensure that the new Daikin AC is installed by a Daikin
              Authorized Service Provider.
            </p>
            <p>
              {" "}
              5. In case of cancellation or refusal for pickup of the old AC
              by the customer, the exchange amount is not applicable.
            </p>
            <p>
              {" "}
              6. The purchase date should be less than 30 days from the date
              of the exchange request to be eligible for this program.
            </p>
            <p> 7. This exchange offer is for individuals, not businesses.</p>
          </p>

          {/* Checkboxes for policy agreement */}
          <div className="agreement-section">
            <label>
              <input
                type="checkbox"
                checked={policyChecked}
                onChange={() => {
                  setPolicyChecked(!policyChecked);
                  setShowPolicyError(false); // Hide error when checkbox is checked
                }}
                className={`checkbox-input ${showPolicyError ? 'checkbox-error' : ''}`} // Add the error class conditionally
              />
              By placing your order, you agree to Selsmart’s
              <Link to="/privacy-policy" target="_blank" className="link-policy">
                {" "}
                Privacy Policy{" "}
              </Link>
              and
              <Link to="/terms-and-conditions" target="_blank" className="link-policy">
                {" "}
                Terms & Conditions
              </Link>
              .
            </label>

            {/* Show error if Privacy Policy checkbox is not checked */}
            {showPolicyError && (
              <div className="error-message-checkbox">
                Please accept the Privacy Policy.
              </div>
            )}


            <label>
              <input
                type="checkbox"
                checked={exchangeValueChecked}
                onChange={() => {
                  setExchangeValueChecked(!exchangeValueChecked);
                  setShowExchangeError(false); // Hide error when checkbox is checked
                }}
                className={`checkbox-input ${showPolicyError ? 'checkbox-error' : ''}`}
              />
              I accept the Exchange Value
            </label>
            {/* Show error if Exchange Value checkbox is not checked */}
            {showExchangeError && (
              <div className="error-message-checkbox">
                Please accept the Exchange Value.
              </div>
            )}
            {/* Confirm Exchange Button */}
            
          </div>
          <div className='confirm_btn text-center'>

          {loading ? (
              <div className="loader"></div>
            ) : (
              <button
                onClick={handleConfirmExchange}
                // disabled={!isConfirmButtonEnabled} // Disable button until both checkboxes are checked
                className="confirm-exchange-button"
              >
                Confirm Exchange
              </button>
            )}
            </div>

        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SummaryPage;
